export default function initializeEnvBar() {
  const envBar = document.getElementById('jsEnvBar');

  if (envBar) {
    const btn = document.getElementById('jsDisableEnvBar');
    document.querySelector('html').classList.add('isShowEnvBar');
    envBar.style.display = 'block';
    btn.addEventListener('click', () => {
      envBar.style.display = 'none';
      document.querySelector('html').classList.remove('isShowEnvBar');
    });
  }
}
